import { message } from "antd";
import { IClient } from "../../contexts/ClientsContext";
import api from "../../services/api";
import apiBolsa from "../../services/bolsa-api";
import { yearConfigPL4173 } from "../../constants/others/exterior";

interface IHandleDarfSend {
  clientsSelected: IClient[];
  sendToWhatsapp?: boolean;
  directDownload?: boolean;
  inputClients?: Array<any>;
  whatsappRedirectURL?: string;
  setWhatsappRedirectURL: any;
  setLoadingGet: any;
  sendToResp: any;
  setSendToResp: any;
  setShowSendDarfModal: any;
  filters: any;
  getClients: any;
  setEmailFlow: any;
  setWhatsappFlow: any;
}
export const handleDarfSend = async ({
  sendToWhatsapp,
  directDownload,
  inputClients,
  clientsSelected,
  whatsappRedirectURL,
  setLoadingGet,
  setWhatsappRedirectURL,
  sendToResp,
  setSendToResp,
  setShowSendDarfModal,
  filters,
  getClients,
  setEmailFlow,
  setWhatsappFlow,
}: IHandleDarfSend) => {
  try {
    const clients =
      clientsSelected.length > 0 ? clientsSelected : inputClients || [];
    if (whatsappRedirectURL) {
      window.open(whatsappRedirectURL, "_blank");
      setWhatsappRedirectURL(undefined);
    } else {
      setLoadingGet(true);
      if (sendToWhatsapp) {
        setWhatsappRedirectURL("loading");
      }
      const { data } = await api.post("/darf/send", {
        clients: clients,
        sendToResp,
        sendToWhatsapp,
      });
      const phone = clients[0].phone;
      const singleClient = data[0] || {};
      const shortPath = singleClient?.shortPath;

      const isExterior = singleClient?.type === 'Exterior'
      const oldModel = (singleClient?.year ?? 2023) < yearConfigPL4173
      const darfLabel = isExterior && !oldModel ? 'relatório' : 'DARF'

      if (shortPath && sendToWhatsapp) {
        const text = `Olá, ${
          singleClient?.name || "Cliente"
        }. Segue seu ${darfLabel} do mês ${singleClient?.month}/${
          singleClient?.year
        }: ${shortPath}`;
        const url = `https://wa.me${
          phone ? `/55${phone}` : ""
        }?text=${text.replaceAll(" ", "%20")}`;
        setWhatsappRedirectURL(undefined);
        window.open(url, "_blank");
      }
      if (!sendToWhatsapp) {
        if (directDownload) {
          handleDarfDownload(shortPath);
        } else {
          message.success(`Envio de ${darfLabel}s realizado`);
          setWhatsappRedirectURL(undefined);
        }
      }
      setShowSendDarfModal(false);
      setWhatsappFlow(false);
      setEmailFlow(false);
      setSendToResp(false);
      getClients({ ...filters, getAllDarfStatus: true, planActive: true });
    }
  } catch (error: any) {
    setWhatsappRedirectURL(undefined);
    if (error.message.includes("400")) {
      message.error("É necessário contratar o plano para emitir e pagar darfs");
    } else {
      message.error("Algo errado aconteceu, tente novamente mais tarde.");
    }
  }
  setLoadingGet(false);
};

export const handleDarfDownload = async (url?: string, idDarf?: string) => {
  if (url) {
    window.open(url, "_blank");
  } else if (idDarf) {
    const token = localStorage.getItem("@VeloTax:token");
    const { data } = await apiBolsa.get(`/darf/download/${idDarf}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    window.open(data?.url || "", "_blank");
  }
};
